
import Vue from 'vue'
import CloseButton from './buttons/CloseButton.vue'
import ActionButtons from './ActionButtons.vue'
import PlayButton from './buttons/PlayButton.vue'
import ActivityDescription from './ActivityDescription.vue'
import IntersectionDetector from './IntersectionDetector.vue'
import { ProjectState, ProjectPath } from '../channel.types'
import { mapGetters, mapState } from 'vuex'
import { URLParameterRange_ActivityType } from '../channel.types'

export default Vue.extend({
  computed: {
    ...mapGetters({
      _isFavorite: 'isFavorite',
    }),

    ...mapState({
      selection: state => (<ProjectState>state).selection,
      article: state => (<ProjectState>state).selection.activity.description,
      projectId: state => (<ProjectState>state).project.id,

      loading: state =>
        (<ProjectState>state).article_engagements.article_loading ||
        !(<ProjectState>state).selection.activity.description,
    }),

    isFavorite() {
      return this._isFavorite(this.selection)
    },

    activityArticleCssClasses() {
      if (!this.selection) {
        return ['activity-article']
      } else {
        let activityId = this.selection.activity.id
        let categoryId = this.selection.row.id
        return [
          'activity-article',
          `article-${activityId}`,
          `category-${categoryId}`,
        ]
      }
    },
  },

  async mounted() {
    let activity = this.selection.activity

    let id = activity.id
    let projectId = this.projectId
    let displayStateId = activity.display_state_id

    await this.$store.dispatch('get_article_text_and_engagements', {
      id,
      projectId,
      displayStateId,
    })
  },

  methods: {
    close() {
      const channelSlug = this.$route.params.channelSlug
      this.$router.push({ path: `/c/${channelSlug}` })
    },

    play() {
      const activityId = this.selection.activity.id
      const rowId = this.selection.row.id
      const channelSlug = this.$route.params.channelSlug
      const articleType = this.selection.row.is_enabled_article_format
        ? URLParameterRange_ActivityType.ARTICLE
        : URLParameterRange_ActivityType.ACTIVITY
      const path = `/c/${channelSlug}/${rowId}/${articleType}/${activityId}/play`

      this.$router.push({ path })
    },

    view() {
      this.$store.dispatch('track_article_view')
    },
    clickLink(link) {
      this.$store.dispatch('track_article_link_click', link)
    },
  },
  components: {
    ActionButtons,
    CloseButton,
    PlayButton,
    ActivityDescription,
    IntersectionDetector,
  },
})
